// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__NPM6g","amountControl":"styles_amountControl__SVuHL","addButton":"styles_addButton__KFjFY"};